import React from 'react'
import { Flex, Loading, Text, Link, Tooltip, Box } from '@workwhile/ui'
import { LunchBreak, Work } from 'pages/Shifts/ShiftDetail/types'
import { WorkerStatus } from 'pages/Shifts/ShiftDetail/components/WorkerRow/WorkerStatus'
import { DayforceWorkerStatus } from './DayforceWorkerStatus'
import { DayforceWorkerActions } from './DayforceWorkerActions'
import * as ROUTES from 'constants/routes'
import { useBookingShiftDetailContextValue } from './BookingShiftDetail/context/BookingShiftDetailProvider'
import { formatInTimeZone } from 'date-fns-tz'
import { DAYFORCE_SHIFTS_DEFAULT_TIMEZONE } from 'pages/Dayforce/constants'

const WorkerRow = ({
  work,
  lunchBreak,
}: {
  work: Work
  lunchBreak?: LunchBreak
}) => {
  const startedAt = work.startedAt
    ? formatInTimeZone(
        work.startedAt,
        DAYFORCE_SHIFTS_DEFAULT_TIMEZONE,
        'EEEE, MMMM d, h:mm a z'
      )
    : null
  const completedAt = work.completedAt
    ? formatInTimeZone(
        work.completedAt,
        DAYFORCE_SHIFTS_DEFAULT_TIMEZONE,
        'EEEE, MMMM d, h:mm a z'
      )
    : null

  const breakDuration = lunchBreak?.durationInMinutes
    ? `${lunchBreak.durationInMinutes} mins`
    : '-'

  const tooltipLabel = (
    <Flex flexDirection="column" gap={1}>
      <Text>Clock-in: {startedAt || '-'}</Text>
      <Text>Clock-out: {completedAt || '-'}</Text>
      <Text>Break duration: {breakDuration}</Text>
    </Flex>
  )

  return (
    <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
      <td style={{ padding: '5px 0' }}>
        <Text>
          {work.worker.name}{' '}
          <Link
            to={ROUTES.USERS.replace(':keyword', work.worker.id.toString())}
            target="_blank"
          >
            ({work.worker.id})
          </Link>
        </Text>
      </td>
      <td align="center">
        <Tooltip content={tooltipLabel}>
          <Box>
            <WorkerStatus status={work.status} minWidth="0" />
          </Box>
        </Tooltip>
      </td>
      <td align="center">
        <DayforceWorkerStatus workerId={work.worker.id} work={work} />
      </td>
      <td align="right">
        <DayforceWorkerActions workerId={work.worker.id} />
      </td>
    </tr>
  )
}

export const Workers = () => {
  const {
    state: { workWhileShift, isLoadingWorkWhileShift },
  } = useBookingShiftDetailContextValue()

  if (isLoadingWorkWhileShift) {
    return <Loading />
  }

  return (
    <Flex flexDirection="column" gap={2}>
      <Text fontSize={3} fontWeight="bold">
        Workers
      </Text>
      {workWhileShift?.work?.length ? (
        <table>
          <thead>
            <tr>
              <th>
                <Text fontWeight="bold">Name</Text>
              </th>
              <th>
                <Text fontWeight="bold" textAlign="center">
                  WW Status
                </Text>
              </th>
              <th>
                <Text fontWeight="bold" textAlign="center">
                  DF Status
                </Text>
              </th>
              <th>
                <Text fontWeight="bold" textAlign="center">
                  Actions
                </Text>
              </th>
            </tr>
          </thead>
          <tbody>
            {workWhileShift?.work.map((work) => (
              <WorkerRow
                key={work.id}
                work={work}
                lunchBreak={workWhileShift.lunchBreak}
              />
            ))}
          </tbody>
        </table>
      ) : (
        <Text>No workers scheduled</Text>
      )}
    </Flex>
  )
}
